import { HStack, Text } from '@chakra-ui/react';
import { NavLink } from 'react-router-dom';

interface Tab {
  label: string;
  path: string;
}

const tabs: Tab[] = [
  { label: 'Pipeline', path: 'pipeline' },
  { label: 'Roster', path: 'roster' },
  { label: 'Notifications', path: 'notifications' },
];

export const TabNavigation = () => {
  return (
    <HStack
      borderBottom="1px solid"
      borderColor="whiteAlpha.100"
      mb={4}
      pb={4}
      spacing={4}
    >
      {tabs.map((tab) => (
        <NavLink key={tab.path} to={tab.path}>
          {({ isActive }) => (
            <Text
              _hover={{ opacity: isActive ? 1 : 0.6 }}
              color="white"
              cursor="pointer"
              fontSize="2xl"
              fontWeight="medium"
              opacity={isActive ? 1 : 0.3}
              transition="opacity 0.2s"
            >
              {tab.label}
            </Text>
          )}
        </NavLink>
      ))}
    </HStack>
  );
};
